import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from "@angular/router";
import {isNullOrUndefined, isUndefined} from "util";
import {OrganizationService} from "../_service/organization.service";
import {Observable} from "rxjs";

/**
 * Created by Rumyantsev Daniil on 11.09.2017.
 */

@Injectable()
export class AliasGuard implements CanActivate {

  constructor(public router: Router, public organizationService: OrganizationService) {
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const alias = route.pathFromRoot[1].params.alias;
    console.log("Alias is ", alias);
    if (isUndefined(alias)) {
      this.router.navigate(["error"]);
    }
    let result = false;

    if (!isNullOrUndefined(localStorage.getItem("organizationAlias")) || localStorage.getItem("organizationAlias") !== alias) {

      await this.organizationService.isAliasExist(alias).then(
        (isAliasExist) => {
          result = this.extracted(isAliasExist, alias, result);
        }, error => {
          this.router.navigate(["error"]);
          return Observable.throw(new Error("error"));
        });
      return result;
    }
  }

  public extracted(isAliasExist, alias, result: boolean) {
    console.warn("In check alias in AliasGuard result: ", isAliasExist);
    if (isAliasExist.isExist) {
      if (!isAliasExist.isActive) {
        this.router.navigate(["info/" + alias + "/inactive-info"]);
        return false;
      }
      localStorage.setItem("organizationAlias", alias);
      return true;
    } else {
      this.router.navigate(["error"]);
      return false;
    }
  }
}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/tmpName/alias.guard.ts